import {QuestionChoiceTypeEnum} from '#apollo/schema';
import {
  MultipleChoiceSelect,
  QuestionControls,
  QuestionText,
} from '#component/partial/Wizard/component';
import {useSurveyVar} from '#component/partial/Wizard/useSurveyVar';
import {sprinkles} from '#style/sprinkles';

import {MultipleChoiceQuestionProps} from './MultipleChoiceQuestion.types';

export const MultipleChoiceQuestion = ({
  onBack,
  onNext,
  options,
  question,
  surveyId,
}: MultipleChoiceQuestionProps) => {
  const {currentValue, onChange} = useSurveyVar({surveyId, question});
  const isMultipleChoice =
    question.multipleChoiceConfiguration?.questionChoiceType === QuestionChoiceTypeEnum.MultiEnum;
  const disabledNext = (currentValue as string[]).length < 1;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!disabledNext) {
      onNext?.();
    }
  };

  return (
    <form
      className={sprinkles({flex: 'flex', dir: 'col', gap: [40, 64, 80]})}
      onSubmit={handleSubmit}>
      <QuestionText text={question.text} description={question.description} />

      <MultipleChoiceSelect
        name={question.id}
        onChange={onChange}
        optionType={isMultipleChoice ? 'checkbox' : 'radio'}
        options={options}
        value={currentValue as string[]}
      />

      <QuestionControls disabledNext={disabledNext} onBack={onBack} />
    </form>
  );
};
